import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function PromoCodeLabel({ promo, showCode = true }) {
  const label = `Промокод${promo?.discountType === 'PERCENT' && promo.discountValue > 0 ? ` (−${promo.discountValue}%)` : ''}`;
  if (!showCode) return <span className='order-totals-promo-label'>{label}</span>;
  return <span>
    <OverlayTrigger placement='top' trigger={['hover', 'focus']}
      overlay={<Tooltip id='order-totals-promo-tooltip' className='order-totals-code-tooltip'>
        <span className='order-totals-promo-code'>{promo.promoCode}</span>
      </Tooltip>}>
      <button type='button' className='order-totals-promo-label order-totals-promo-info'
        aria-label={`${label}. Показати код`} onClick={event => event.currentTarget.focus()}>
        <i className='bi bi-tag mr-1' aria-hidden='true' />{label}
      </button>
    </OverlayTrigger>
  </span>;
}
